module.exports = __webpack_public_path__ + "static/media/change-transfer-table.ff38df6b.svg";